
export function isContentValid(action: any) {
  return action?.actionBody?.contentIds?.length > 0;
}